import { constants } from "./constants";
import { GiftCard } from "./types/graphql-global-types";

class Util {
    copyToClipboard(text: string) {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        // Avoid scrolling to bottom
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.position = 'fixed';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        var copied = false;

        try {
            var successful = document.execCommand('copy');
            copied = successful ? true : false;
        } catch (err) {
            console.error(err);
        }

        document.body.removeChild(textArea);
        return copied;
    }

    /**
     * Check if object is empty or not
     */
    isEmpty(object: any) {
        return Object.keys(object).length === 0;
    }

    addCustomStyle(url: string) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = 'retailer';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.media = 'all';
        head.appendChild(link);
    }

    getUTCDate(dateString: string) {
        var date = new Date(dateString);
        return Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        );
    }

    getCardImageUrl(card: GiftCard): string {
        const custom_url = constants.BASE_IMAGE_URL + `${card?.retailerid}/${card?.card?.cardimagename}?${Date.now()}`;
        return card?.card?.url ? card?.card?.url : custom_url;
    }
}

export default new Util();
